import * as address from './address.js';
import * as anchor from './anchor.js';
import * as button from './button.js';
import * as dialog from './dialog.js';
import * as fieldset from './fieldset.js';
import * as figure from './figure.js';
import * as hr from './hr.js';
import * as iframe from './iframe.js';
import * as image from './image.js';
import * as input from './input.js';
import * as list from './list.js';
import * as screenReader from './screen-reader.js';
import { rootCls } from './side-effect.index.js';
import * as text from './text.js';
import * as touch from './touch.js';

/**
 * Expose all individual resets as well as our root className which merges the
 * resets, allowing consumers full control over the exact reset that they may
 * need
 */
const resets = {
  ...address,
  ...anchor,
  ...button,
  ...dialog,
  ...hr,
  ...input,
  ...fieldset,
  ...iframe,
  ...text,
  ...list,
  ...image,
  ...figure,
  ...touch,
  ...screenReader,
  rootCls
};

export { resets };
//# sourceMappingURL=index.js.map
